"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var moveOutOfStockProductsLast = function moveOutOfStockProductsLast(mappedProducts) {
  var outOfStockProducts = [];
  var inStockProducts = [];
  mappedProducts.forEach(function (product) {
    if (product.availability.level === "270") {
      outOfStockProducts.push(product);
    } else {
      inStockProducts.push(product);
    }
  });
  return [].concat(inStockProducts, outOfStockProducts);
};
var _default = moveOutOfStockProductsLast;
exports["default"] = _default;